import { BrowserMultiFormatReader } from '@zxing/browser';

const barCodeReader = new BrowserMultiFormatReader();

export { barCodeReader }
